module.exports = __webpack_public_path__ + "static/media/clock.b24b83ef.svg";